import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import DayView from '../views/DayView.vue';

const routes = [
  { path: '/', component: Home },
  { path: '/dia/:dia', component: DayView, props: true }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
